import type { Messages } from "@prop/i18n";
import type en from "../en/coach";

export default {
  nav: "Коуч",
  title: "Коуч",
  lead: "Откуда берётся ваш результат, ментор, который читает ваши сделки, и путь к funded-аккаунту.",
  account: "Аккаунт",
  tabs: { analytics: "Карта преимуществ", mentor: "Ментор", playbook: "Playbook", academy: "Академия", path: "Путь к funded" },
  day: { warning: "Осторожно — близко к лимиту", locked: "Заблокировано до конца дня", reasons: { green_to_red: "день отдал слишком много от пика", personal_daily_loss: "ваш личный дневной лимит" } },
  guard: {
    codes: {
      COACH_PAUSE_AFTER_LOSS: "пауза после убытка",
      COACH_REENTRY_LIMIT: "лимит перезаходов",
      COACH_TRADE_LIMIT: "сделок за день",
      COACH_GREEN_TO_RED: "из зелёного в красное",
      COACH_OUTSIDE_WINDOW: "вне вашего окна",
      COACH_PERSONAL_DAILY_LOSS: "ваш дневной лимит",
    },
  },
  analytics: {
    dimension: "Группировать по",
    dims: { instrument: "Инструмент", side: "Сторона", hour: "Час", weekday: "День недели", holding: "Время в позиции", setup: "Сетап" },
    trades: "Сделок",
    net: "Итог",
    winRate: "Винрейт",
    pf: "Профит-фактор",
    payoff: "Payoff",
    dd: "Макс. просадка",
    netTotal: "Итог по всем закрытым сделкам",
    rowLine: "{trades} сделок · винрейт {win} · PF {pf}",
    emptyTitle: "Закрытых сделок пока нет",
    empty: "Закройте несколько сделок, и карта покажет, какие инструменты, часы и сетапы дают результат.",
    toTerminal: "Открыть терминал",
    zone: "Время в {tz}",
  },
  mentor: {
    intro: "Ментор читает ваши сделки, правила и лимиты — никаких рыночных подсказок. Ответы — коучинг, а не инвестиционный совет.",
    brief: "Бриф перед сессией",
    debrief: "Дебриф после сессии",
    weekly: "Недельный обзор",
    off: "Ментор для вашего аккаунта пока не включён.",
    thinking: "Ментор читает ваши сделки…",
    none: "Сессий пока нет. Попросите бриф перед торговлей или дебриф после.",
    memory: "Память",
    memoryLead: "Что ментор держит в голове: ваши обязательства, заметки и факты. Отметьте обязательство, когда выполните.",
    kind: "Тип",
    text: "Текст",
    placeholders: { commitment: "Например: не входить в первые 15 минут", note: "Например: сегодня мало спал", fact: "Например: лучше всего торгую на открытии Лондона" },
    add: "Добавить",
    kinds: { note: "Заметка", fact: "Факт", commitment: "Обязательство" },
  },
  playbook: {
    new: "Новый сетап",
    intro: "Назовите свои сетапы и помечайте ими закрытые сделки — карта преимуществ покажет результат каждого.",
    name: "Название сетапа",
    tag: "Тег",
    tagHint: "Строчные латинские буквы, цифры и дефисы; заполняется из названия.",
    rules: "Правила входа и выхода",
    add: "Сохранить сетап",
    saved: "Сетап сохранён.",
    list: "Ваши сетапы",
    none: "Сетапов пока нет. Сохранённые появятся здесь.",
    tagTrade: "Сетап",
    followed: "Следовал плану",
  },
  academy: {
    title: "Уроки",
    progress: "Прочитано {done} из {total}",
    done: "Отметить прочитанным",
    completed: "Прочитано",
    lessons: {
      "risk-of-ruin": { title: "Риск разорения", body: "При риске 1 % на сделку десять убытков подряд стоят около 10 %. При 5 % — 40 %. Считайте объём от стопа, а не от уверенности." },
      "daily-loss": { title: "Дневной лимит", body: "Лимит считается по equity, вместе с открытыми убытками, от границы дня программы. Оставляйте запас: останавливайтесь раньше лимита." },
      "position-sizing": { title: "Размер позиции", body: "Количество = риск в $ ÷ (расстояние до стопа × стоимость пункта). Тикет делает это за вас: «объём от риска»." },
      tilt: { title: "Тильт", body: "После убытка сильнее всего желание отыграться. Отойдите на несколько минут, а следующую сделку считайте от стопа, а не от убытка." },
      journaling: { title: "Журнал", body: "Помечайте каждую сделку сетапом и тем, следовали ли плану. Через месяц карта преимуществ покажет, что оставить и что убрать." },
      "execution-policy": { title: "Как здесь исполняются ордера", body: "Ордер исполняется мгновенно — за 10–30 мс, без добавленной задержки, по реальному стакану; лимитки встают в очередь. Каждое исполнение хранит снимок — «Почему здесь» в блоттере." },
    },
  },
  path: {
    intro: "Ваш путь, шаг за шагом.",
    steps: { challenge: "Начать челлендж", first_trade: "Первая сделка", phase_passed: "Пройти фазу", kyc: "Подтвердить личность", funded: "Funded-аккаунт", first_payout: "Первая выплата" },
    actions: { challenge: "Открыть аккаунт", first_trade: "Открыть терминал", phase_passed: "Открыть терминал", kyc: "Пройти проверку", funded: "К аккаунтам", first_payout: "К выплатам" },
    badges: "Значки",
    earned: "{n} из {total}",
    achievements: {
      first_trade: "Первая сделка",
      ten_trades: "Десять сделок",
      green_day: "Зелёный день",
      plan_followed_5: "5 раз по плану",
      academy_done: "Академия пройдена",
      phase_passed: "Фаза пройдена",
      funded: "Funded",
      first_payout: "Первая выплата",
    },
  },
  admin: {
    tab: "Эксперименты",
    flag: "Флаг",
    enabled: "Вкл.",
    rollout: "Доля treatment, %",
    save: "Сохранить",
    variant: "Вариант",
    users: "Пользователи",
    pF: "Pass rate p_f",
    q: "Выплатили q",
    dll: "Нарушения DLL",
    retention: "Удержание 7 дней",
  },
} satisfies Messages<typeof en>;
